import { PubSub } from "tsfront/pubsub";

export const pubsub_ = new PubSub();

//export default pubsub_;

export const authListenerId = 'AuthListener';
export const langListenerId = 'LangListener';

// export const markSlateId = 'markSlate';//?
// export const slateValue = {};//?



